#include<Filter>

uniform sampler2D textureMouseTrail;

void main(void) {
    vec4 circleMask = texture2D(textureMouseTrail, vUV);
    float trailMouseMask = circleMask.r;
    vec4 color = getFuryImage(trailMouseMask);
    gl_FragColor = color;
}